import { ActionIcon, Title } from '@mantine/core';
import { useUnit } from 'effector-react';
import { ChevronLeft } from 'lucide-react';
import { devicePageModel } from 'pages/device-page/model';
import { useBreakpoint } from 'shared/lib';
import { router } from 'shared/routing';
import cls from './device-page-heading.module.scss';

export const DevicePageHeading = () => {
	const [device, back] = useUnit([devicePageModel.$device, router.back]);

	const md = useBreakpoint('md');

	return (
		device !== null && (
			<div className={cls.devicePageHeading}>
				<ActionIcon
					variant='outline'
					onClick={back}
				>
					<ChevronLeft />
				</ActionIcon>
				<Title
					order={1}
					size={md ? 'h1' : 'h3'}
					className={cls.devicePageHeadingTitle}
				>
					{device.name}
				</Title>
			</div>
		)
	);
};
